module.exports = __webpack_public_path__ + "media/app/assets/specializations/mage/frost-0719b8f27fb02a4f9de34702f2371066.png";